var $be15883e6181a852$exports = {};
$be15883e6181a852$exports = {
    "removeButtonLabel": `Odebrat`,
    "removeDescription": `Stisknut\xedm kl\xe1vesy Delete odeberete zna\u{10D}ku.`
};


export {$be15883e6181a852$exports as default};
//# sourceMappingURL=cs-CZ.mjs.map
